import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  if (response?.data?.status !== 'FAILURE') {
    return response?.data
  } else {
    if (Array.isArray(response?.data)) {
      return response?.data
    } else {
      throw response
    }
  }
}

const getGroupsListReq = (groupId: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getGroupList),
    body: groupId.length > 0 ? { identificationNumber: groupId } : {},
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getGroupsListReq }
